export default __webpack_public_path__ + "static/media/12.9d9dea83.png";